/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_CAS_CASHES_ITEM = {
  id: 'cashes',
  screenId: 'fin-cas-cashes',
  label: 'Cajas',
  description: 'Alta de cajas e imputaciones para diferencias al abrir o cerrar.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Acá das de alta las cajas de efectivo y definís a qué conceptos se imputan las diferencias cuando, al abrir o cerrar una caja, el efectivo contado no coincide con el saldo del sistema.',
      },
      {
        title: 'Paso 1 — Leer la lista',
        bullets: [
          'Columnas: Descripción, Moneda, Faltantes, Sobrantes y Estado (Abierta o Cerrada).',
          'Faltantes y Sobrantes muestran los centros de costo e ingreso configurados para esa caja.',
          'Tocá una fila para ver el detalle completo.',
          'Podés exportar la lista con el ícono de descarga de la grilla.',
        ],
      },
      {
        title: 'Paso 2 — Crear una caja',
        intro: 'El botón + abre «Nueva caja». Todos los campos son obligatorios:',
        fields: [
          { label: 'Descripción', description: 'Nombre de la caja (por ejemplo «Caja mostrador»).' },
          { label: 'Moneda', description: 'Moneda en la que opera la caja (pesos, dólares, etc.).' },
          {
            label: 'Imputación de faltantes de caja',
            description:
              'Centro de costo (gasto) al que se cargará cuando falte efectivo respecto al sistema. Buscá escribiendo al menos 3 letras y elegí el concepto del árbol de gastos.',
          },
          {
            label: 'Imputación de sobrantes de caja',
            description:
              'Centro de ingresos al que se cargará cuando sobre efectivo respecto al sistema. Buscá escribiendo al menos 3 letras y elegí el concepto del árbol de ingresos.',
          },
        ],
        paragraphs: [
          'Tocá «Crear caja» para guardar. Estas imputaciones se usan automáticamente al confirmar un faltante o sobrante en la apertura o cierre de caja.',
        ],
      },
      {
        title: 'Paso 3 — Ver o cambiar imputaciones',
        bullets: [
          'Tocá una caja en la lista para abrir su detalle.',
          'Ahí ves descripción, moneda, estado y las imputaciones actuales.',
          'El botón «Editar imputaciones de faltantes y sobrantes» permite cambiar los centros de costo e ingreso asignados.',
        ],
      },
      {
        title: '¿Cuándo se usan faltantes y sobrantes?',
        paragraphs: [
          'Al abrir o cerrar una caja (desde Movimientos, con el ícono del candado) ingresás el efectivo contado. Si no coincide con el saldo del sistema, el sistema te pide confirmar la diferencia.',
          'Si falta dinero, se imputa al centro de costo (gasto) configurado en Faltantes.',
          'Si sobra dinero, se imputa al centro de ingresos configurado en Sobrantes.',
        ],
      },
    ],
  },
}
